export function CompactQuoteFormStyles() {
  return (
    <style>
      {`
        .B2C-compact-quote-form {
          --B2C-form-row-gap: 0.5rem;
        }

        .B2C-compact-quote-form > * + * {
          margin-top: 0.625rem !important;
        }

        .B2C-compact-quote-form [class*="space-y-5"] > * + *,
        .B2C-compact-quote-form [class*="space-y-6"] > * + * {
          margin-top: 0.625rem !important;
        }

        .B2C-compact-quote-form [class*="gap-2"] {
          gap: var(--B2C-form-row-gap) 0.625rem;
        }

        .B2C-compact-quote-form label {
          gap: 0.3rem;
          line-height: 1.2;
        }

        .B2C-compact-quote-form label:not(.inline-flex) {
          font-size: 12px;
        }

        .B2C-compact-quote-form input:not([type="radio"]):not([type="checkbox"]),
        .B2C-compact-quote-form [class*="h-9"] {
          min-height: 2.25rem;
          height: 2.25rem;
          padding-top: 0.35rem;
          padding-bottom: 0.35rem;
        }

        .B2C-compact-quote-form [class*="min-h-10"] {
          min-height: 2.25rem;
          padding-top: 0.35rem;
          padding-bottom: 0.35rem;
        }

        .B2C-compact-quote-form [class*="grid-cols-"] > * {
          min-width: 0;
        }

        .B2C-compact-quote-form h3 {
          line-height: 1.25;
          margin-bottom: 0.125rem;
        }

        .B2C-compact-quote-form p.text-xs {
          line-height: 1.35;
        }

        .B2C-compact-quote-form .space-y-3 > * + * {
          margin-top: 0.5rem !important;
        }

        .B2C-compact-quote-form label.inline-flex {
          min-height: 2rem !important;
          padding: 0.3rem 0.4rem !important;
          font-size: 11px;
          line-height: 1.15;
        }

        .B2C-compact-quote-form label.inline-flex input[type="radio"],
        .B2C-compact-quote-form label.inline-flex input[type="checkbox"] {
          width: 0.85rem;
          height: 0.85rem;
          margin-top: 0;
        }

        .B2C-compact-quote-form [class*="text-theme-danger"] {
          margin-top: 0.2rem;
        }
      `}
    </style>
  );
}
